import * as React from "react";
import { user } from "src/services/api";
import { Props, State, Visor } from './Visor';

interface LocalProps extends Props {
}

interface LocalState extends State {
}

export default class VisorDocente extends Visor<LocalProps, LocalState> {
  
  public getLocalVal( key ) {
    if (key === 'id') return user.id;
    if (key === 'label') return user.nome;
    if (key === 'type') return 'docente';
  }
}


// WEBPACK FOOTER //
// ./src/components/ecommerce/VisorDocente.tsx